import { REGISTRATION_STATES } from './registrationStatus';

export const soleProprietor = 'SOLE_PROPRIETOR';
export const standard = 'STANDARD';
export const lowStandard = 'LOW_STANDARD';

export const brandSteps = [
    {
        name: "Complete Form",
    },
    {
        name: "Registration Fee",
        pendingCta: "Pay Registration Fee",
        pendingAction: "fee",
    },
    {
        name: "Identity Review",
        errorCta: "Fix Identity Verification",
        errorAction: "standard_brand"
    },
    {
        name: "Message Type Review",
        errorCta: "Fix Message Types",
        errorAction: "standard_campaign"
    },
    {
        name: "Approved",
        // TODO - Add hyperlink to comms/campaings pages - add hyperlinks to compliance guide
        copy: `<span>You are now able to use the power of texting in LionDesk for <a href="/communications/text">1-1 communications</a> and <a href="/communications/text2sell">Text2Sell</a>!</span>
        <br><span>Be sure to review this <a href="https://lonewolf.my.site.com/s/article/LD-What-is-SMS-consent-and-how-do-I-obtain-it-LionDesk" target="_blank">guide to texting compliance</a> to maintain your good reputation with your contacts and the mobile carriers.</span>
        <br><span>To safeguard your custom number's reputation with carriers, mass texting is not supported in LionDesk.</span>`,
        copyBulkTexts: `<span>You are now able to use the power of texting in LionDesk for <a href="/communications/text">1-1 communications</a> and <a href="/communications/text2sell">Text2Sell</a>!</span>
        <br><span>Be sure to review this <a href="https://lonewolf.my.site.com/s/article/LD-What-is-SMS-consent-and-how-do-I-obtain-it-LionDesk" target="_blank">guide to texting compliance</a> to maintain your good reputation with your contacts and the mobile carriers.</span>`
    },
]

export const businessSteps = [
    {
        name: "Complete Form",
    },
    {
        name: "Registration Fee",
        pendingCta: "Pay Registration Fee",
        pendingAction: "fee",
        errorCta: "",
        errorAction: ""
    },
    {
        name: "Identity Review",
        pendingCta: "",
        pendingAction: "",
        errorCta: "Fix Identity Verification",
        errorAction: "brand"
    },
    {
        name: "Mobile Verification",
        pendingCta: "Resend Verification Text",
        pendingAction: "text",
        errorCta: "Start Registration Again",
        errorAction: "brand"
    },
    {
        name: "Message Type Review",
        pendingCta: "",
        pendingAction: "",
        errorCta: "Fix Message Types",
        errorAction: "campaign"
    },
    {
        name: "Approved",
        // TODO - Add hyperlink to comms/campaings pages - add hyperlinks to compliance guide
        copy: `<span>You are now able to use the power of texting in LionDesk for <a href="/communications/text">1-1 communications</a> and <a href="/communications/text2sell">Text2Sell</a>!</span>
        <br><span>Be sure to review this <a href="https://lonewolf.my.site.com/s/article/LD-What-is-SMS-consent-and-how-do-I-obtain-it-LionDesk" target="_blank">guide to texting compliance</a> to maintain your good reputation with your contacts and the mobile carriers.</span>
        <br><span>To safeguard your custom number's reputation with carriers, mass texting is not supported in LionDesk.</span>`,
        copyBulkTexts: `<span>You are now able to use the power of texting in LionDesk for <a href="/communications/text">1-1 communications</a> and <a href="/communications/text2sell">Text2Sell</a>!</span>
        <br><span>Be sure to review this <a href="https://lonewolf.my.site.com/s/article/LD-What-is-SMS-consent-and-how-do-I-obtain-it-LionDesk" target="_blank">guide to texting compliance</a> to maintain your good reputation with your contacts and the mobile carriers.</span>`
    },
]

export const failedStatuses = [
    'payment_failed',
    'customer_profile_failed',
    'a2p_bundle_failed',
    'brand_failed',
    'brand_tcr_failed',
    'brand_otp_failed',
    'campaign_failed',
    'campaign_twilio_failed',
    'campaign_tcr_failed'
]

export const errorStatuses = [
    'customer_profile_error',
    'a2p_bundle_error',
    'brand_error',
    'campaign_error',
    'brand_otp_error',
]

export const blockedStatuses = [
    REGISTRATION_STATES.BRAND_BLOCKED_FAILED,
    REGISTRATION_STATES.BRAND_BLOCKED_TCR_FAILED,
    REGISTRATION_STATES.CAMPAIGN_BLOCKED_FAILED,
    REGISTRATION_STATES.CAMPAIGN_BLOCKED_TCR_FAILED,
];

export function getStepByStatusAndType(status, type) {
    switch (type) {
        case soleProprietor:
            switch (status) {
                case 'data_registration_saved':
                case 'brand_pending':
                case 'payment_pending':
                case 'payment_failed':
                case 'payment_campaign_retry_pending':
                case 'payment_brand_retry_pending':
                    return 2;
                case 'payment_received':
                case 'brand_submitted':
                case 'brand_error':
                case 'customer_profile_error':
                case 'customer_profile_failed':
                case 'a2p_bundle_error':
                case 'a2p_bundle_failed':
                case 'brand_failed':
                case 'brand_tcr_failed':
                case 'payment_brand_retry_received':
                case REGISTRATION_STATES.BRAND_BLOCKED_FAILED:
                case REGISTRATION_STATES.BRAND_BLOCKED_TCR_FAILED:
                    return 3;
                case 'brand_completed':
                case 'brand_otp_pending':
                case 'brand_otp_error':
                case 'brand_otp_failed':
                    return 4;
                case 'brand_otp_completed':
                case 'campaign_submitted':
                case 'campaign_pending':
                case 'campaign_error':
                case 'campaign_failed':
                case 'campaign_twilio_failed':
                case 'campaign_tcr_failed':
                case 'payment_campaign_retry_received':
                case REGISTRATION_STATES.CAMPAIGN_BLOCKED_FAILED:
                case REGISTRATION_STATES.CAMPAIGN_BLOCKED_TCR_FAILED:
                    return 5;
                case 'campaign_completed':
                    return 6;
            }
        case lowStandard:
        case standard:
            switch (status) {
                case 'data_registration_saved':
                case 'brand_pending':
                case 'payment_pending':
                case 'payment_failed':
                case 'payment_campaign_retry_pending':
                case 'payment_brand_retry_pending':
                    return 2;
                case 'payment_received':
                case 'brand_submitted':
                case 'brand_error':
                case 'customer_profile_error':
                case 'customer_profile_failed':
                case 'a2p_bundle_error':
                case 'a2p_bundle_failed':
                case 'brand_failed':
                case 'brand_tcr_failed':
                case 'payment_brand_retry_received':
                case REGISTRATION_STATES.BRAND_BLOCKED_FAILED:
                case REGISTRATION_STATES.BRAND_BLOCKED_TCR_FAILED:
                    return 3;
                case 'brand_completed':
                case 'campaign_submitted':
                case 'campaign_pending':
                case 'campaign_error':
                case 'campaign_failed':
                case 'campaign_twilio_failed':
                case 'campaign_tcr_failed':
                case 'payment_campaign_retry_received':
                case REGISTRATION_STATES.CAMPAIGN_BLOCKED_FAILED:
                case REGISTRATION_STATES.CAMPAIGN_BLOCKED_TCR_FAILED:
                    return 4;
                case 'campaign_completed':
                    return 5;
            }
    }
}
